import { BaseFetch } from "../main-model"
export default class DesirableCharacteristicsModel extends BaseFetch {
    getDesirableCharacteristicsBy = (data) =>
    this.authFetch({
      url: "desirable-characteristics/getDesirableCharacteristicsBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getDesirableCharacteristicsById = (data) =>
    this.authFetch({
      url: "desirable-characteristics/getDesirableCharacteristicsById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertDesirableCharacteristics = (data) =>
    this.authFetch({
      url: "desirable-characteristics/insertDesirableCharacteristics",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateDesirableCharacteristicsById = (data) =>
    this.authFetch({
      url: "desirable-characteristics/updateDesirableCharacteristicsById",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteDesirableCharacteristicsById = (data) =>
    this.authFetch({
      url: "desirable-characteristics/deleteDesirableCharacteristicsById",
      method: "POST",
      body: JSON.stringify(data),
    })
    getDesirableCharacteristicsWithBehaviorBy = (data) =>
    this.authFetch({
      url: "desirable-characteristics/getDesirableCharacteristicsWithBehaviorBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteDesirableCharacteristicsWithBehavior = (data) =>
    this.authFetch({
      url: "desirable-characteristics/deleteDesirableCharacteristicsWithBehavior",
      method: "POST",
      body: JSON.stringify(data),
    })
    
}
